<template>
  <g class="radar-mesh">
    <circle
      v-for="circle in circles"
      :key="circle.id"
      :r="circle.circleRadius"
      stroke="rgba(255,255,255,0.2)"
      fill="transparent"
      style="transform: translateX(50%) translateY(50%);"
      class="g-circles"
    />
  </g>
</template>

<script>
import { gsap, TimelineMax, TweenMax, DrawSVGPlugin } from 'gsap/all';

gsap.registerPlugin(DrawSVGPlugin);

export default {
  name: 'RadarMesh',

  props: {
    radius: {
      type: Number,
      required: true,
    },
    circleCount: {
      type: Number,
      required: true,
    },
  },

  computed: {
    circles() {
      return [...Array(this.circleCount).keys()].map((circle, index) => ({
        circleRadius: this.radius - (this.radius / this.circleCount) * index,
        id: index,
      }));
    },
  },

  mounted() {
    // TODO: refactor heavy
    if (this.$route.name === 'dashboard') {
      // Animation start scripts
      TweenMax.set('.g-circles', { strokeOpacity: 0 });
      const tl_radar = new TimelineMax();
      tl_radar.staggerTo('.g-circles', 1, { scale: 0.9, strokeOpacity: 0.2 }, 0.2);
      tl_radar.staggerTo('.g-circles', 2, { scale: 1, strokeOpacity: 1.0 }, 0.2);

      // Little circle pieces being animated
      TweenMax.set('.radar_section_line circle', { strokeDashoffset: '348%' });
      const tl_lines = new TimelineMax();
      tl_lines.staggerTo('.radar_section_line circle', 0.5, { strokeDashoffset: '378%' }, 0.1);

      // The clickable dot svg's
      TweenMax.set('.radar_dot .radar_dot__inner', { scale: 0.2, opacity: 0 });
      const tl_circles = new TimelineMax();
      tl_circles.delay(1.5);
      tl_circles.staggerTo('.radar_dot .radar_dot__inner', 0.25, { opacity: 1, scale: 1 }, 0.1);

      // The outside animated ones.
      TweenMax.set('.radar_dot .radar_dot__pulsing', { display: 'block', opacity: 0 });
      const tl_circles_pulsing = new TimelineMax();
      tl_circles_pulsing.delay(2);
      tl_circles_pulsing.staggerTo('.radar_dot .radar_dot__pulsing', 1, { opacity: 1 }, 0.1);

      // The actual graph
      TweenMax.set('.radar__chartOld', { scale: 0 });
      TweenMax.to('.radar__chartOld', 1, { delay: 1, scale: 1, ease: 'easeOutBounce' });
    } else {
      // hide
      TweenMax.set('.radar_dot .radar_dot__pulsing', { display: 'none' });
    }
  },
};
</script>
<style lang="scss" scoped>
.radar-mesh circle {
  stroke-width: 1;

  @include helper__greater($bp-1024) {
    stroke-width: 0.5;
  }
}
</style>
